import React, { useEffect } from "react";
import Highcharts from "highcharts";
import HighchartsHeatmap from "highcharts/modules/heatmap";

if (typeof Highcharts === "object") {
  HighchartsHeatmap(Highcharts);
}

const data = [
  [0, 0, 244.22],
  [0, 1, 265.96],
  [0, 2, 145.86],
  [0, 3, 133.83],

  [1, 0, 238.45],
  [1, 1, 260.44],
  [1, 2, 150.38],
  [1, 3, 134.62],

  [2, 0, 255.04],
  [2, 1, 264.34],
  [2, 2, 145.9],
  [2, 3, 135.06],

  [3, 0, 255.04],
  [3, 1, 264.34],
  [3, 2, 145.9],
  [3, 3, 135.06],
];

const values = data.map((d) => d[2]);
const minValue = Math.min(...values);
const maxValue = Math.max(...values);

const HeatmapChart = () => {
  useEffect(() => {
    // First Heatmap
    Highcharts.chart("container1", {
      chart: {
        type: "heatmap",
        plotBorderWidth: 0,
      },
      title: {
        text: "Network Comparison: % of Medicare ",
        style: {
          color: "#333333",
          fontFamily: "'Montserrat', serif",
          fontSize: "20px",
          fontWeight: "bold",
        },
      },
      subtitle: {
        text: " Description: 4 by 4 Heat Map, Single Color",
        style: {
          color: "#333333",
          fontFamily: "'Montserrat', serif",
          fontSize: "12px",
          fontWeight: "Light",
        },
      },
      xAxis: {
        categories: [
          "Anthem High Performance Network",
          "Anthem Traditional Network",
          "BC ID Blue Value POS Network",
          "BC ID Preferred Blue Network",
        ],
        title: {
          text: "Carrier",
          style: {
            fontFamily: "'Roboto Flex', serif",
          },
        },
        lineWidth: 0,
      },
      yAxis: {
        categories: [
          "Inpatient (IPPS)",
          "Outpatient (OPPS)",
          "Professional (PFS)",
          "Medicare Part B Drugs (DrugB)",
        ],
        title: {
          text: "Category",
          style: { fontFamily: "'Roboto Flex', serif" },
        },
        labels: {
          style: {
            fontSize: "12px",
            width: "100px",
          },
        },
        reversed: true,
      },
      colorAxis: {
        height: "78.5%",
        min: 0,
        max: 1000,
        stops: [
          [0, "#E0F3FF"],
          [0.5, "#aecbeb"],
          [1, "#012a4a"],
        ],
      },
      legend: {
        align: "right",
        layout: "vertical",
        margin: 0,
        verticalAlign: "top",
        y: 25,
        symbolHeight: 280,
      },
      // tooltip: {
      //   formatter: function () {
      //     return `<b>${this.series.yAxis.categories[this.point.y]}</b><br>
      //             <b>${this.series.xAxis.categories[this.point.x]}:</b> ${
      //       this.point.value
      //     }`;
      //   },
      // },

      tooltip: {
        pointFormatter: function () {
          return `<b>${this.series.yAxis.categories[this.y]}</b><br>
          <span style="color: #E96926; font-size: 14px;">&#9472;&#9472;&#9472;</span> <br>
            <b>${this.series.xAxis.categories[this.x]}:</b> ${this.value}`;
        },
        shared: true,
        backgroundColor: "rgba(255, 255, 255, 1)",
        borderColor: "#A9A9A9",
        borderRadius: 7,
        animation: false,
        hideDelay: 0,
        style: {
          color: "#333",
          fontFamily: "'Roboto Flex', serif",
          transition: "none",
          fontSize: "12px",
          padding: "8px",
          shadow: "1px 1px 1px rgba(232, 232, 232, 0.1)",
          zIndex: 99999,
        },
        shadow: true,
        useHTML: true,
        outside: true,
      },
      credits: {
        enabled: false,
      },
      series: [
        {
          opacity: 1,
          states: {
            hover: {
              enabled: false,
            },

            inactive: {
              opacity: 1,
            },

            halo: {
              opacity: 1,
            },
            select: {
              enabled: false,
              halo: {
                opacity: 1,
              },
            },
          },
          name: "Network Comparison",
          borderWidth: 1,
          borderColor: "#ffffff",
          borderRadius: 5,
          data: [
            [0, 0, 244.22],
            [0, 1, 265.96],
            [0, 2, 145.86],
            [0, 3, 133.83],

            [1, 0, 238.45],
            [1, 1, 260.44],
            [1, 2, 150.38],
            [1, 3, 134.62],

            [2, 0, 255.04],
            [2, 1, 264.34],
            [2, 2, 145.9],
            [2, 3, 135.06],

            [3, 0, 255.04],
            [3, 1, 264.34],
            [3, 2, 145.9],
            [3, 3, 135.06],
          ],
          dataLabels: {
            enabled: true,
            color: "#fff",
            backgroundColor: "#093150",
            borderRadius: 5,
            padding: 5,
            style: {
              fontSize: "12px",
              fontWeight: "light",
              textOutline: "none",
            },
            formatter: function () {
              return this.point.value + "%"; // Keeps the original value and adds a % sign
            },
          },
        },
      ],
    });
    Highcharts.chart("container3", {
      chart: {
        type: "heatmap",
        plotBorderWidth: 0,
      },
      title: {
        text: "Network Comparison: % of Medicare ",
        style: {
          color: "#333333",
          fontFamily: "'Montserrat', serif",
          fontSize: "20px",
          fontWeight: "bold",
        },
      },
      subtitle: {
        text: " Description: No Decimal Value Data Label, 6 Row, Single Color   ",
        style: {
          color: "#333333",
          fontFamily: "'Montserrat', serif",
          fontSize: "12px",
          fontWeight: "Light",
        },
      },
      xAxis: {
        categories: [
          "Anthem High Performance Network",
          "Anthem Traditional Network",
          "BC ID Blue Value POS Network",
          "BC ID Preferred Blue Network",
        ],
        title: {
          text: "Carrier",
          style: {
            fontFamily: "'Roboto Flex', serif",
          },
        },
        lineWidth: 0,
      },
      yAxis: {
        categories: [
          "Inpatient (IPPS)",
          "Outpatient (OPPS)",
          "Professional (PFS)",
          "Medicare Part B Drugs (DrugB)",
        ],
        title: {
          text: "Category",
          style: { fontFamily: "'Roboto Flex', serif" },
        },
        labels: {
          style: {
            fontSize: "12px",
            width: "100px",
          },
        },
        reversed: true,
      },
      colorAxis: {
        height: "78.5%",
        min: 0,
        max: 1000,
        stops: [
          [0, "#E0F3FF"],
          [0.5, "#aecbeb"],
          [1, "#012a4a"],
        ],
      },
      legend: {
        align: "right",
        layout: "vertical",
        margin: 0,
        verticalAlign: "top",
        y: 25,
        symbolHeight: 280,
      },

      tooltip: {
        pointFormatter: function () {
          return `<b>${this.series.yAxis.categories[this.y]}</b><br>
          <span style="color: #E96926; font-size: 14px;">&#9472;&#9472;&#9472;</span> <br>
            <b>${this.series.xAxis.categories[this.x]}:</b> ${this.value}`;
        },
        shared: true,
        backgroundColor: "rgba(255, 255, 255, 1)",
        borderColor: "#A9A9A9",
        borderRadius: 7,
        animation: false,
        hideDelay: 0,
        style: {
          color: "#333",
          fontFamily: "'Roboto Flex', serif",
          transition: "none",
          fontSize: "12px",
          padding: "8px",
          shadow: "1px 1px 1px rgba(232, 232, 232, 0.1)",
          zIndex: 99999,
        },
        shadow: true,
        useHTML: true,
        outside: true,
      },
      credits: {
        enabled: false,
      },
      series: [
        {
          opacity: 1,
          states: {
            hover: {
              enabled: false,
            },

            inactive: {
              opacity: 1,
            },

            halo: {
              opacity: 1,
            },
            select: {
              enabled: false,
              halo: {
                opacity: 1,
              },
            },
          },
          name: "Network Comparison",
          borderWidth: 1,
          borderColor: "#ffffff",
          borderRadius: 5,
          data: [
            [0, 0, 244.22],
            [0, 1, 265.96],
            [0, 2, 145.86],
            [0, 3, 133.83],
            [0, 4, 290.63],
            [0, 5, 240.33],

            [1, 0, 238.45],
            [1, 1, 260.44],
            [1, 2, 150.38],
            [1, 3, 134.62],
            [1, 4, 190.62],
            [1, 5, 200.83],

            [2, 0, 255.04],
            [2, 1, 264.34],
            [2, 2, 145.9],
            [2, 3, 135.06],
            [2, 4, 180.06],
            [2, 5, 200.83],

            [3, 0, 255.04],
            [3, 1, 264.34],
            [3, 2, 145.9],
            [3, 3, 135.06],
            [3, 4, 280.06],
            [3, 5, 200.83],
          ],
          dataLabels: {
            enabled: true,
            color: "#fff",
            backgroundColor: "#093150",
            borderRadius: 5,
            padding: 5,
            style: {
              fontSize: "12px",
              fontWeight: "light",
              textOutline: "none",
            },
            formatter: function () {
              return Math.round(this.point.value) + "%"; // Rounds off the value and removes %
            },
          },
        },
      ],
    });
    // Second Heatmap
    Highcharts.chart("container2", {
      chart: {
        type: "heatmap",
        plotBorderWidth: 0,
      },
      title: {
        text: "Network Comparison: % of Medicare",
        style: {
          color: "#333333",
          fontFamily: "'Montserrat', serif",
          fontSize: "20px",
          fontWeight: "bold",
        },
      },
      subtitle: {
        text: " Description: Deerhold Theme Color, Dynamic Scale  ",
        style: {
          color: "#333333",
          fontFamily: "'Montserrat', serif",
          fontSize: "12px",
          fontWeight: "Light",
        },
      },
      xAxis: {
        categories: [
          "Anthem High Performance Network",
          "Anthem Traditional Network",
          "BC ID Blue Value POS Network",
          "BC ID Preferred Blue Network",
        ],
        title: {
          text: "Carrier",
          style: {
            fontFamily: "'Roboto Flex', serif",
          },
        },
        lineWidth: 0,
      },
      yAxis: {
        categories: [
          "Inpatient (IPPS)",
          "Outpatient (OPPS)",
          "Professional (PFS)",
          "Medicare Part B Drugs (DrugB)",
        ],
        title: {
          text: "Category",
          style: { fontFamily: "'Roboto Flex', serif" },
        },
        labels: {
          style: {
            fontSize: "12px",
            width: "100px",
          },
        },
        reversed: true,
      },
      colorAxis: {
        height: "78.5%",
        min: minValue, // Dynamically set min
        max: maxValue, // Dynamically set max
        stops: [
          [0, "#E76B2A"],
          // [0.25, "#110E11"],
          // [0.5, "#e2e2e2"],
          // [0.75, "#aecbeb"],
          [1, "#4990CB"],
        ],
      },
      legend: {
        align: "right",
        layout: "vertical",
        margin: 0,
        verticalAlign: "top",
        y: 25,
        symbolHeight: 280,
      },
      tooltip: {
        pointFormatter: function () {
          return `<b>${this.series.yAxis.categories[this.y]}</b><br>
          <span style="color: #E96926; font-size: 14px;">&#9472;&#9472;&#9472;</span> <br>
            <b>${this.series.xAxis.categories[this.x]}:</b> ${this.value}%`;
        },
        shared: true,
        backgroundColor: "rgba(255, 255, 255, 1)",
        borderColor: "#A9A9A9",
        borderRadius: 7,
        animation: false,
        hideDelay: 0,
        style: {
          color: "#333",
          fontFamily: "'Roboto Flex', serif",
          transition: "none",
          fontSize: "12px",
          padding: "8px",
          shadow: "1px 1px 1px rgba(232, 232, 232, 0.1)",
          zIndex: 99999,
        },
        shadow: true,
        useHTML: true,
        outside: true,
      },
      credits: {
        enabled: false,
      },
      series: [
        {
          opacity: 1,
          states: {
            hover: {
              enabled: false,
            },

            inactive: {
              opacity: 1,
            },

            halo: {
              opacity: 1,
            },
            select: {
              enabled: false,
              halo: {
                opacity: 1,
              },
            },
          },
          name: "Network Comparison",
          borderWidth: 1,
          borderColor: "#ffffff",
          borderRadius: 5,
          data: data,
          dataLabels: {
            enabled: true,
            color: "#fff",
            backgroundColor: "#093150",
            borderRadius: 5,
            padding: 5,
            style: {
              fontSize: "12px",
              fontWeight: "light",
              textOutline: "none",
            },
            formatter: function () {
              return this.point.value + "%"; // Keeps the original value and adds a % sign
            },
          },
        },
      ],
    });
    Highcharts.chart("container4", {
      chart: {
        type: "heatmap",
        plotBorderWidth: 0,
      },
      title: {
        text: "Network Comparison: % of Medicare",
        style: {
          color: "#333333",
          fontFamily: "'Montserrat', serif",
          fontSize: "20px",
          fontWeight: "bold",
        },
      },
      subtitle: {
        text: " Description: Two Color Scale Heat Map, Dynamic Scale",
        style: {
          color: "#333333",
          fontFamily: "'Montserrat', serif",
          fontSize: "12px",
          fontWeight: "Light",
        },
      },
      xAxis: {
        categories: [
          "Anthem High Performance Network",
          "Anthem Traditional Network",
          "BC ID Blue Value POS Network",
          "BC ID Preferred Blue Network",
        ],
        title: {
          text: "Carrier",
          style: {
            fontFamily: "'Roboto Flex', serif",
          },
        },
        lineWidth: 0,
      },
      yAxis: {
        categories: [
          "Inpatient (IPPS)",
          "Outpatient (OPPS)",
          "Professional (PFS)",
          "Medicare Part B Drugs (DrugB)",
        ],
        title: {
          text: "Category",
          style: { fontFamily: "'Roboto Flex', serif" },
        },
        labels: {
          style: {
            fontSize: "12px",
            width: "100px",
          },
        },
        reversed: true,
      },
      colorAxis: {
        height: "78.5%",
        min: minValue, // Dynamically set min
        max: maxValue, // Dynamically set max
        stops: [
          [0, "#597988"],
          [0.25, "#e9edc9"],
          [0.5, "#fefae0"],
          [0.75, "#faedcd"],
          [1, "#C8E6E6"],
        ],
      },
      legend: {
        align: "right",
        layout: "vertical",
        margin: 0,
        verticalAlign: "top",
        y: 25,
        symbolHeight: 280,
      },
      tooltip: {
        pointFormatter: function () {
          return `<b>${this.series.yAxis.categories[this.y]}</b><br>
          <span style="color: #E96926; font-size: 14px;">&#9472;&#9472;&#9472;</span> <br>
            <b>${this.series.xAxis.categories[this.x]}:</b> ${this.value}%`;
        },
        shared: true,
        backgroundColor: "rgba(255, 255, 255, 1)",
        borderColor: "#A9A9A9",
        borderRadius: 7,
        animation: false,
        hideDelay: 0,
        style: {
          color: "#333",
          fontFamily: "'Roboto Flex', serif",
          transition: "none",
          fontSize: "12px",
          padding: "8px",
          shadow: "1px 1px 1px rgba(232, 232, 232, 0.1)",
          zIndex: 99999,
        },
        shadow: true,
        useHTML: true,
        outside: true,
      },
      credits: {
        enabled: false,
      },
      series: [
        {
          opacity: 1,
          states: {
            hover: {
              enabled: false,
            },

            inactive: {
              opacity: 1,
            },

            halo: {
              opacity: 1,
            },
            select: {
              enabled: false,
              halo: {
                opacity: 1,
              },
            },
          },
          name: "Network Comparison",
          borderWidth: 1,
          borderColor: "#ffffff",
          borderRadius: 5,
          data: data,
          dataLabels: {
            enabled: true,
            color: "#fff",
            backgroundColor: "#023047",
            borderRadius: 5,
            padding: 5,
            style: {
              fontSize: "12px",
              fontWeight: "light",
              textOutline: "none",
            },
            formatter: function () {
              return this.point.value + "%"; // Keeps the original value and adds a % sign
            },
          },
        },
      ],
    });
  }, []);

  return (
    <div>
      <div
        id="container1"
        style={{ width: "100%", height: "500px", marginBottom: "40px" }}
      />
      <div
        id="container3"
        style={{ width: "100%", height: "500px", marginBottom: "40px" }}
      />
      <div
        id="container4"
        style={{ width: "100%", height: "500px", marginBottom: "40px" }}
      />
      <div id="container2" style={{ width: "100%", height: "500px" }} />
    </div>
  );
};

export default HeatmapChart;
